module.exports = __webpack_public_path__ + "img/whitecirarw.4f59af47.svg";